import { useTranslation } from "../i18n/useTranslation";

/**
 * An explicit choice is available even when the browser language is English.
 *
 * Español may need the Spanish catalogue first (rc.12 (b)). While it loads
 * after a press, the press shows as taken (Español pressed) and the group as
 * busy, with no new words; a second Español press does nothing, and English
 * stays instant. It ends on the switch, or on English if the load fails.
 */
export function LanguageSwitch() {
  const { locale, switching, chooseLocale } = useTranslation();
  const spanish = locale === "es" || switching;
  return (
    <div className="b-language-switch" role="group" aria-label="Language / Idioma" aria-busy={switching ? "true" : undefined}>
      <button type="button" lang="en" aria-pressed={!spanish} onClick={() => chooseLocale("en")}>English</button>
      <button type="button" lang="es" aria-pressed={spanish} onClick={() => chooseLocale("es")}>Español</button>
    </div>
  );
}
